import React from 'react';
import { makeStyles } from '@material-ui/core';
import {
	Edit,
	SimpleForm,
	TextInput,
	SelectInput,
	BooleanInput,
	required,
	Toolbar,
	SaveButton,
	useTranslate
} from 'react-admin';
import { Typography } from '@material-ui/core';
import { Grid } from '../../components/wrapper';
import businessContractParameters from '../businessContractParameters';
import businessContractRoutes from '../businessContractRoutes';
import BusinessContractEditActions from './BusinessContractEditActions';

const businessContractTypes = [
	{ id: 'BankContract', name: 'BankContract' },
	{ id: 'AcquirerContract', name: 'AcquirerContract' },
	{ id: 'CryptoContract', name: 'CryptoContract' }
];

const useStyles = makeStyles({
	titles: {
		marginTop: 10,
		marginBottom: 20
	},
	edit: {
		marginBottom: 24
	},
	list: {
		marginBottom: 24
	}
});

const BusinessContractToolbar = props => (
	<Toolbar {...props}>
		<SaveButton />
	</Toolbar>
);

const BusinessContractEdit = props => {
	const translate = useTranslate();
	const classes = useStyles();
	return (
		<React.Fragment>
			<Edit {...props} className={classes.edit} actions={<BusinessContractEditActions />}>
				<SimpleForm variant="standard" toolbar={<BusinessContractToolbar />}>
					<Grid container spacing={2}>
						<Grid item xs>
							<TextInput source="id" fullWidth disabled />
							<TextInput source="status" fullWidth disabled />
							<TextInput source="subsidiaryId" validate={required()} fullWidth />
							<SelectInput
								source="type"
								choices={businessContractTypes}
								validate={required()}
								fullWidth
							/>
						</Grid>
						<Grid item xs>
							<TextInput source="paymentMethodName" validate={required()} fullWidth />
							<TextInput source="qualifier1" fullWidth />
							<TextInput source="qualifier2" fullWidth />
							<TextInput source="comment" fullWidth />
						</Grid>
						{/* TODO address */}
						<Grid item xs>
							<BooleanInput source="supportsAuthorize" />
							<BooleanInput source="supportsPreauthorize" />
							<BooleanInput source="supportsCapture" />
							<BooleanInput source="supportsCredit" />
							<BooleanInput source="supportsRefund" />
							<BooleanInput source="supportsReverse" />
						</Grid>
					</Grid>
				</SimpleForm>
			</Edit>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.businessContractParameters.labels.title')}
			</Typography>
			<businessContractParameters.list
				{...props}
				title=" "
				resource={'businessContractParameters'}
				filter={{ id: props.id }}
				className={classes.list}
			/>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.businessContractRoutes.labels.title')}
			</Typography>
			<businessContractRoutes.list
				{...props}
				title=" "
				basePath={'/businessContractRoutes'}
				resource={'businessContractRoutes'}
				filter={{ businessContractId: props.id }}
				className={classes.list}
			/>
		</React.Fragment>
	);
};

export default BusinessContractEdit;
